import { render, staticRenderFns } from "./pay_index.vue?vue&type=template&id=1880ec56&scoped=true&"
import script from "./pay_index.vue?vue&type=script&lang=js&"
export * from "./pay_index.vue?vue&type=script&lang=js&"
import style0 from "./pay_index.vue?vue&type=style&index=0&id=1880ec56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880ec56",
  null
  
)

export default component.exports